import React from 'react'
import styles from './about_web_app.module.css'

export default function AboutWebImgs(props) {

    return (
        <div className="flex flex-col items-center justify-center">
            <div className="flex flex_center"><img className="w-52 h-52" src={require(`../../assets/icons/${props.img}.svg`)} alt="imgs" /></div>
            <h3 className="primary_color font-bold mt-1 xs:text-sm sm:text-sm md:text-lg lg:text-lg">{props.title}</h3>
            <h4 className="text-sm secondry_color w-4/6 text-justify">{props.subTitle}</h4>
        </div>
    )
}